import { useState } from "react";
import { createPaymentMethod } from "../../api/invoiceService";

export const useCreatePaymentMethod = (successCallback) => {
  const [creating, setCreating] = useState(false);
  const create = async (data) => {
    setCreating(true);
    try {
      const newRecord = await createPaymentMethod(data);
      setCreating(false);
      if (successCallback)
      {
        successCallback(newRecord);
      }
        return newRecord;
    } catch (error) {
      setCreating(false);
      console.error("Failed to create payment method:", error);
      throw error; // rethrow so the component can handle errors
    }
  };

  return { create, creating };
};